import React, { useEffect, useState, useRef } from "react";
import { Modal, Radio } from "antd";
import SignagePlayer from "../SignagePlayer";
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';

const PreviewPlaylist = ({ isModalOpen, playlist, closeModal }) => {
  const [orientation, setOrientation] = useState("horizontal");
  const playerRef = useRef();

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const modalWidth = orientation === "horizontal" ? 450 : 275; // adjust as needed
  const playerHeight = 400;

  return (
    <Modal
      title={`Preview Playlist - ${playlist.title}`}
      open={isModalOpen}
      onCancel={() => {
        closeModal();
      }}
      footer={null}
      maskClosable={false}
    >
      <div className="mb-3">
        <label className="form-label me-3">Orientation</label>
        <Radio.Group
          onChange={handleOrientationChange}
          value={orientation}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value="horizontal">Horizontal</Radio>
          <Radio value="vertical">Vertical</Radio>
        </Radio.Group>
      </div>
      <div
        className={`preview-media-container ${orientation}`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: playerHeight,
          overflow: "hidden",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {playlist.media.length > 1 && <LeftCircleOutlined style={{ fontSize: 25, marginRight: 10 }} onClick={() => {
              playerRef.current?.prevMedia();
          }} />}
          <SignagePlayer
            ref={playerRef}
            playlist={playlist.media.map((media) => {
              return { media: media, duration: media.duration };
            })}
            classNames={`preview-media ${orientation}`}
            enableControls={true}
          ></SignagePlayer>
          {playlist.media.length > 1 && <RightCircleOutlined style={{ fontSize: 25, marginLeft: 10 }} onClick={() => {
              playerRef.current?.nextMedia();
          }} />}
        </div>
      </div>
    </Modal>
  );
};

export default PreviewPlaylist;
